export default __webpack_public_path__ + "static/media/me-icon.0813b156.webp";